import type { ComponentProps } from "react"

export default function IndustryO(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M28 21.3335V4.00016C28 4.00016 24 1.3335 16 1.3335C8 1.3335 4 4.00016 4 4.00016V21.3335L16 30.6668L28 21.3335ZM13.5072 20.3071L24.7072 9.10708L23.293 7.69287L12.8001 18.1858L8.70718 14.0929L7.29297 15.5071L12.093 20.3071C12.4835 20.6976 13.1167 20.6976 13.5072 20.3071Z"
        fill={fill}
      />
    </svg>
  )
}
